export interface FrameRect { sx: number; sy: number; sw: number; sh: number; }
export interface SpriteSheet { image: HTMLImageElement; frames: FrameRect[]; }

export function sliceSheet(image: HTMLImageElement, frameW: number, frameH: number): FrameRect[] {
  const cols = Math.floor(image.width / frameW);
  const rows = Math.floor(image.height / frameH);
  const out: FrameRect[] = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      out.push({ sx: c * frameW, sy: r * frameH, sw: frameW, sh: frameH });
    }
  }
  return out;
}

export async function loadSpriteSheet(src: string, frameW: number, frameH: number): Promise<SpriteSheet> {
  const image = await new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`failed to load sprite ${src}`));
    img.src = src;
  });
  return { image, frames: sliceSheet(image, frameW, frameH) };
}
